import { storage } from '@connect-x-app/hybrid-utils';
import { AppConfig } from '@connect-x-app/shared-types';
import { DEVICE_ID_STORAGE_KEY } from '@connect-x-app/shared-utils';
import { version } from '@connect-x-app/version';
import { v4 as uuidv4, validate as uuidValidate } from 'uuid';
import { create } from 'zustand';

type Platform = 'web' | 'ios' | 'android' | 'macos' | 'windows';

const getDeviceId = () => {
  let deviceId = storage.getItem(DEVICE_ID_STORAGE_KEY);
  if (!deviceId || !uuidValidate(deviceId)) {
    deviceId = uuidv4();
    storage.setItem(DEVICE_ID_STORAGE_KEY, deviceId);
  }
  return deviceId;
};

type AppConfigSessionStoreState = {
  appConfig: AppConfig;
  initializeAppConfig: (platform: Platform) => void;
  updateAppConfig: (partial: Partial<AppConfig>) => void;
};

export const useAppConfigSessionStore = create<AppConfigSessionStoreState>((set, get) => ({
  appConfig: {
    account: '',
    deviceId: getDeviceId(),
    installBundleId: '',
    type: '',
    version,
  },
  initializeAppConfig: (platform: Platform) => {
    const current = get().appConfig;
    const type = `CONNECT-${platform.toUpperCase()}`;
    if (current.type !== type) {
      set({ appConfig: { ...current, type } });
    }
  },
  updateAppConfig: (partial: Partial<AppConfig>) =>
    set(state => ({
      appConfig: {
        ...state.appConfig,
        ...partial,
      },
    })),
}));
